import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Youtube, Facebook, Music2 } from "lucide-react";
import { Logo } from "@/components/Logo";

const COLS = [
  {
    title: "Card Care",
    links: [
      { label: "Pokémon Card Cleaning", to: "/pokemon-card-cleaning" },
      { label: "Sports Card Cleaning", to: "/sports-card-cleaning" },
      { label: "Baseball Card Cleaning", to: "/baseball-card-cleaning" },
      { label: "Card Grading Prep", to: "/card-grading-prep" },
      { label: "Mail-In Card Cleaning", to: "/mail-in-card-cleaning" },
      { label: "High-Value Card Care", to: "/high-value-card-care" },
    ],
  },
  {
    title: "Learn & Explore",
    links: [
      { label: "Before & After", to: "/before-after" },
      { label: "The Library", to: "/library" },
      { label: "How It Works", to: "/how-it-works" },
      { label: "Comic Cleaning", to: "/comic-cleaning" },
      { label: "Comic Preservation", to: "/comic-preservation" },
      { label: "Results", to: "/results" },
    ],
  },
  {
    title: "The Lab",
    links: [
      { label: "Trust Center", to: "/trust-center" },
      { label: "After Hours", to: "/after-hours" },
      { label: "About The Lab", to: "/about" },
      { label: "Confidentiality", to: "/confidentiality" },
      { label: "Shipping & Insurance", to: "/shipping-insurance" },
      { label: "Submit A Collectible", to: "/submit" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer className="bg-black border-t border-[color:var(--line)] mt-24">
      <div className="shimmer-line" />
      <div className="mx-auto max-w-[1400px] px-5 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <Logo />
            <p className="text-sm text-[color:var(--chrome-3)] mt-5 max-w-xs leading-relaxed">
              A dedicated collectibles laboratory — inspection, responsible cleaning, preparation,
              preservation and presentation. Clean. Prep. Preserve.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {[Instagram, Music2, Youtube, Facebook].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="p-2.5 rounded-lg border border-[color:var(--line)] text-[color:var(--chrome-2)] hover:text-white hover:border-[color:var(--cyan)] transition-colors"
                  aria-label="social"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {COLS.map((c) => (
            <div key={c.title}>
              <h4 className="eyebrow mb-5">{c.title}</h4>
              <ul className="space-y-3">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-sm text-[color:var(--chrome-2)] hover:text-white transition-colors"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t border-[color:var(--line)] space-y-4">
          <p className="text-xs text-[color:var(--chrome-3)] max-w-4xl leading-relaxed">
            CardScience HQ is not affiliated with, endorsed by, sponsored by or approved by PSA, CGC, Beckett,
            SGC or any other independent grading company unless explicitly stated otherwise. Independent grading
            companies determine all grades. No grade is guaranteed and past results do not guarantee future results.
          </p>
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-[color:var(--chrome-3)]">
              © {new Date().getFullYear()} CardScienceHQ.com — CARD HQ. All rights reserved.
            </p>
            <p className="font-tech text-[10px] tracking-[0.42em] text-[color:var(--chrome-3)]">
              COLLECT MORE POSSIBILITIES
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
